import { IDetails } from '../types/IStoreDetails'
import { IStoresList } from '../types/IStoresList'
import { ApiClient } from './ApiClient'
import webApi from './webApi'

const defaultStoreTypes = 'main,local,pfs,restaurant'

const getStore = async (
  apiClient: ApiClient,
  code: string
): Promise<IDetails> => {
  const storeCode = code !== '' ? code : ''

  const response = await webApi.get<IDetails>(apiClient, {
    url: '/api/storelocator/store',
    params: { storeCode: storeCode }
  })

  return response ? response : {code}
}

const getStores = async (
  apiClient: ApiClient,
  query: any | undefined = '',
  lat: number | undefined = 0,
  lon: number | undefined = 0,
  storeTypeFilter: string = defaultStoreTypes
): Promise<IDetails[]> => {
  const response = await webApi.get<IStoresList>(apiClient, {
    url: '/api/storelocator/stores',
    params: { store_type: storeTypeFilter, lat: lat, lon: lon, search: query }
  })

  return response.results
}

const storesApi = {
  getStore,
  getStores
}

export default storesApi